import { Route, Switch } from 'react-router-dom';
import { Commons } from 'components';
import { WhatsApp } from 'components/Commons';
import Error404 from 'pages/Error/Error404';
import Login from 'pages/LoginRegistro/Login';
import Registro from 'pages/LoginRegistro/Registro';
import RecuperarContrasenia from 'pages/LoginRegistro/Password';
import ShareTable from 'pages/TableAdmin/ShareTable';
import MyTables from 'newPages/MyEvents';
import MyTablesOld from 'pages/TableAdmin/MyTables';
import SearchTables from 'newPages/SearchTables';
import SearchTables2 from 'pages/TableAdmin/SearchTables';
import ThankYou from 'pages/TableFlow/ThankYou';
import TableAdmin from 'pages/TableAdmin';
import TableByPass from 'pages/TableByPass';
import GuestLanding from 'pages/TableAdmin/GuestLanding';
import NewGuestLanding from 'newPages/GuestLanding';
import HomePlan from 'pages/Home/Plan';
import ProtectedRoute from 'components/gifts-table/ProtectedRoute';
import ProtectedRouteSSO from 'components/gifts-table/ProtectedRouteSSO';
import AgentPageRoute from 'components/gifts-table/AgentPageRoute';
import TableFlow from 'pages/TableFlow';
import Home2 from 'pages/Home';
import Home from 'newPages/Home';
import MoreQuestions from 'pages/Home/HomeFAQ/MoreQuestions';
import Reviews from 'pages/Reviews';
import {
  ListOfGiftsReceived,
  GiftReceivedDetail,
  GiftReceivedDetailv2,
  MyWallet,
} from 'pages/GiftsReceived';
import NewListOfGiftsReceived from 'newPages/ListOfGiftsReceived'
import { ArticlesToPay, BuyGifts, GiftDedication } from 'pages/PaymentFlow';
import AddGifts from 'pages/AddGifts';
import AddGifts2 from 'newPages/AddGifts';
import AddGiftsByExternalLink from 'pages/AddGiftsByExternalLink';
import AgentLogin from 'pages/LoginRegistro/AgentLogin';
import { isLogged } from 'services/commons';
import Authenticated from 'pages/LoginRegistro/Authenticated';
import Guest from 'pages/LoginRegistro/Guest';
import BeforeGuest from 'pages/LoginRegistro/BeforeGuest';
import ByPass from 'pages/TableAdmin/ByPass';
import BaseInfo from 'pages/TableAdmin/BaseInfo';
import MyCoupon from 'pages/TableAdmin/MyCoupon';
import AddGiftsMobile from 'pages/AddGifts/mobile';

// import MyGuests from 'pages/TableAdmin/MyGuests/MyGuests';
import Rsvp from 'pages/Rsvp/';
import MyguestAdd from 'pages/TableAdmin/MyGuests/MyGuestsAdd';
import MyCompanionAdd from 'pages/TableAdmin/MyGuests/MyCompanionAdd';
import MyGuestsCompanion from 'pages/TableAdmin/MyGuests/MyGuestsCompanion';
import MyGuestsExcel from 'pages/TableAdmin/MyGuests/MyGuestsExcel';
import Invitation from 'pages/Rsvp/Invitation';
import PreBuyGifts from 'newPages/BuyGifts/PreBuyGifts';
import BuyGiftsNew from 'newPages/BuyGifts/BuyGifts';
import NewGiftDedication from 'newPages/Payments/PaymentFlow';
import NewTableAdmin from 'newPages/MyTable';

export default function Routes() {
  const isUserLogged = isLogged();
  const whatsApp = isUserLogged ? <WhatsApp /> : null;
  return (
    <>
      <Commons />
      {whatsApp}
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/home" exact component={Home2} />
        <Route path="/authenticated/" component={Authenticated} />
        <Route path="/faqs" extract component={MoreQuestions} />
        <Route path="/planes" extract component={HomePlan} />
        <Route path="/review" exact component={Reviews} />

        <AgentPageRoute path="/crear-mesa/:agentId/admin-page" strict exact component={TableFlow} />
        <ProtectedRoute path="/crear-mesa-new" exact component={TableFlow} />
        <ProtectedRouteSSO path="/crear-mesa" exact component={TableFlow} />

        {/* Invitaciones RSVP  */}
        <ProtectedRoute path="/rsvp" exact component={Rsvp} />
        <ProtectedRoute path="/agrega-invitados" exact component={MyguestAdd} />
        <ProtectedRoute path="/agrega-acompanante/:guestId" exact component={MyCompanionAdd} />
        <ProtectedRoute path="/muestra-invitados" exact component={MyGuestsCompanion} />
        <ProtectedRoute path="/agrega-invitados-excel/:guestId" exact component={MyGuestsExcel} />
        <ProtectedRoute path="/agrega-invitados-excel/:guestId/:indicaPaso" exact component={MyGuestsExcel} />
        <ProtectedRoute path="/agrega-invitados-excel/:guestId/:indicaPaso/:load" exact component={MyGuestsExcel} />
        <Route path="/invitation/:tableId" exact component={Invitation} />
        <Route path="/invitation/:tableId/:guestId" exact component={Invitation} />

        <ProtectedRoute path="/mis-mesas" exact component={MyTables} />
        <ProtectedRoute path="/mis-mesas-old" exact component={MyTablesOld} />
        <ProtectedRoute path="/my-info" exact component={BaseInfo} />
        <ProtectedRoute path="/my-cupon" exact component={MyCoupon} />
        <Route path="/compartir-mesa" exact component={ShareTable} />
        
        <Route path="/buscar-evento" exact component={SearchTables} />
        <Route path="/buscar-evento-old" exact component={SearchTables2} />

        <Route path="/login" component={Login} />
        <Route path="/registro" exact component={Registro} />
        <Route path="/guest" exact component={Guest} />
        <Route path="/before-guest" exact component={BeforeGuest} />
        <Route path="/recuperar-contrasena/" component={RecuperarContrasenia} />
        <Route path="/gracias" component={ThankYou} />
        <Route path="/admin-login/:agentId" exact component={AgentLogin} />

        <Route path="/old/invitado/:eventId" exact component={GuestLanding} />
        <Route path="/invitado/:eventId" exact component={NewGuestLanding} />

        <Route path="/:eventId/:name/old" exact component={GuestLanding} />
        <Route path="/:eventId/:name" exact component={NewGuestLanding} />
        
        <ProtectedRoute path="/my-table-bypass" exact component={TableByPass} />
      {/*  <ProtectedRoute
          path="/buy-gifts/:tableId/buy"
          exact
          component={BuyGifts}
        /> */}
        <Route
          path="/buy-gifts/old/:tableId/buy"
          exact
          component={BuyGifts}
        />

        <ProtectedRoute
          path="/buy-gifts/:tableId/buy"
          exact
          component={BuyGiftsNew}
        />

        <ProtectedRoute
          path="/pre-buy-gifts/:tableId/buy"
          exact
          component={PreBuyGifts}
        />
        
        <ProtectedRoute
          strict={false}
          path="/agregar-regalos-old"
          component={AddGifts}
        />

        <ProtectedRoute
          strict={false}
          path="/agregar-regalos"
          component={AddGifts2}
        />

        <ProtectedRoute
          strict={false}
          path="/escanear-productos"
          component={AddGiftsMobile}
        />

        <ProtectedRoute
          strict={false}
          path="/my-table"
          component={NewTableAdmin}
        />
        <ProtectedRoute
          strict={false}
          path="/old/my-table"
          component={TableAdmin}
        />


        <ProtectedRoute
          strict={false}
          path="/my-tablebypass"
          component={ByPass}
        />
        
         <ProtectedRoute
          exact
          strict={false}
          path="/regalos-recibidos-old"
          component={ListOfGiftsReceived}
        />
        <ProtectedRoute
          exact
          strict={false}
          path="/regalos-recibidos/:id/details"
          component={GiftReceivedDetail}
        />
        <ProtectedRoute
          exact
          strict={false}
          path="/regalos-recibidos/:id/detailsv2"
          component={GiftReceivedDetailv2}
        />
        <ProtectedRoute
          exact
          strict={false}
          path="/regalos-recibidos"
          component={NewListOfGiftsReceived}
        />
        <ProtectedRoute exact strict={false} path="/my-wallet" component={MyWallet} />

        <Route path="/payment" exact component={ArticlesToPay} />
        <Route
          path="/add-gifts-by-external-link"
          exact
          component={AddGiftsByExternalLink}
        />
        <Route
          path="/old/payment-flow/:tableId/steps-flow"
          exact
          component={GiftDedication}
        />
        <ProtectedRoute
          path="/payment-flow/:tableId/steps-flow"
          exact
          component={NewGiftDedication}
        />
        {/* <ProtectedRoute
          path="/payment-flow/:tableId/steps-flow"
          exact
          component={GiftDedication}
        /> */}
        <Route path="/:anything*" component={Error404} />
      </Switch>
    </>
  );
}
